import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import RiskScoreDashboard from "@/pages/RiskScoreDashboard";
import CustomerDetailPage from "@/pages/CustomerDetailPage";
import CreditPortfolioDashboard from "@/pages/CreditPortfolioDashboard";
import CapacityPlanningDashboard from "@/pages/CapacityPlanningDashboard";
import OnboardingList from "@/pages/OnboardingList";
import OnboardingWizard from "@/pages/OnboardingWizard";
import ApplicationStatus from "@/pages/ApplicationStatus";
import RiskSimulator from "@/pages/RiskSimulator";
import FraudDashboard from "@/pages/FraudDashboard";
import { Sidebar } from "@/components/Sidebar";
import { Toaster } from "@/components/ui/sonner";

import { useEffect } from "react";

function App() {
  useEffect(() => {
    const kill = setInterval(() => {
      const el = document.getElementById("emergent-badge");
      if (el) el.remove();
    }, 150);
    return () => clearInterval(kill);
  }, []);

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <BrowserRouter>
        <Sidebar />
        <div className="ml-56 transition-all duration-300">
          <Routes>
            <Route path="/" element={<CreditPortfolioDashboard />} />
            <Route path="/portfolio-health" element={<CreditPortfolioDashboard />} />
            <Route path="/risk-score" element={<RiskScoreDashboard />} />
            <Route path="/risk-score/:customerId" element={<CustomerDetailPage />} />
            <Route path="/capacity-planning" element={<CapacityPlanningDashboard />} />
            <Route path="/onboarding" element={<OnboardingList />} />
            <Route path="/onboarding/apply" element={<OnboardingWizard />} />
            <Route path="/onboarding/status/:appId" element={<ApplicationStatus />} />
            <Route path="/risk-simulator" element={<RiskSimulator />} />
            <Route path="/fraud-intelligence" element={<FraudDashboard />} />
          </Routes>
        </div>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
